module.exports = __webpack_public_path__ + "img/lemon_meringue_pie_cut.86a121cd.jpg";